import { Feature, Service } from "@/generated/graphql_billing";

// FeatureExt extends Features with computed properties.
export interface FeatureExt extends Feature {
  isEnabled: boolean;
}

export const getFeatureExtList = (service: Service): FeatureExt[] => {
  const allFeatures = service.allFeatures || [];
  const planFeatureCodes = new Set(
    (service.planFeatures || []).map((feature) => feature.code)
  );
  return allFeatures.map((feature) => ({
    ...feature,
    isEnabled: planFeatureCodes.has(feature.code),
  }));
};
